export interface IDomErrorHandler {
    saveErrorToDom(translationMissing: boolean, message?: any, ...optionalParams: any[]): void;
    getClientErrorString(): string;
    clearDomErrorStorage(): void;
}
